import moment from 'moment-timezone'
import { calcDaysCount } from '@/utils/selectPackage'
import TierPricing from './tierPricing'
import Price from './price'

export default class Availability {
  id: number
  minGuestCount: number
  startsAt: Date
  endsAt: Date
  availableSpotsCount: number
  bookWithPortion: string
  timezone: string
  finalPaymentDate: Date
  tierPricings: TierPricing[]
  useTierPricing: boolean
  checkoutTierPricing: TierPricing
  price: Price
  includedInPriceHtml: string[]
  name: string

  constructor(attrs: any) {
    this.id = +attrs.id
    this.minGuestCount = +attrs.minGuestCount
    this.availableSpotsCount = +attrs.availableSpotsCount
    this.startsAt = new Date(attrs.startsAt)
    this.endsAt = new Date(attrs.endsAt)
    this.bookWithPortion = attrs.bookWithPortion
    this.timezone = attrs.timezone
    this.finalPaymentDate = moment.tz(attrs.finalPaymentDate, attrs.timezone).toDate()
    this.tierPricings = attrs.tierPricings ? attrs.tierPricings.map(tp => new TierPricing(tp)) : []
    this.useTierPricing = attrs.useTierPricing
    this.checkoutTierPricing = attrs.checkoutTierPricing ? new TierPricing(attrs.checkoutTierPricing) : null
    this.price = attrs.price ? new Price(attrs.price) : null
    this.includedInPriceHtml = attrs.includedInPriceHtml || []
    this.name = attrs.name
  }

  public get firstTierPrice(): number {
    if (!this.tierPricings || !this.tierPricings.length) return 0

    return this.tierPricings[0].priceCents
  }

  public get currentTierPrice(): number {
    if (this.useTierPricing && this.checkoutTierPricing) {
      return this.checkoutTierPricing.priceCents
    }
    return this.firstTierPrice
  }

  public get daysCount(): number {
    return calcDaysCount(this)
  }

  public get nightsCount(): number {
    return this.daysCount - 1
  }
}
